import { pickThemeColor } from '@/theme';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  counter-reset: section;

  & > section:nth-child(odd) {
    background-color: ${pickThemeColor('BG_SECONDARY')};
    border-block: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
  }
`;
